import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from '../../../shared/toast.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private toastService: ToastService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;

    // Add token to all requests except login
    const token = localStorage.getItem('auth_token') || localStorage.getItem('temp_auth_token');
    if (token) {
      if (!req.url.includes('/login')) {
        authReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
      }
    } else {
      this.sessionExpired();
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage: string;
        if (error instanceof HttpErrorResponse) {
          const getMsg = (fallback: string) => error?.error?.message ?? fallback;
          switch (error.status) {
            case 400:
              errorMessage = getMsg('Bad request');
              break;
            case 401:
              errorMessage = getMsg('Unauthorized');
              this.sessionExpired();
              break;
            case 403:
              errorMessage = getMsg('Forbidden');
              this.forbiddenRoute();
              break;
            case 404:
              errorMessage = getMsg('Not found');
              break;
            case 405:
              errorMessage = getMsg('Method Not Allowed');
              break;
            case 406:
              errorMessage = getMsg('Not Acceptable');
              break;
            case 408:
              errorMessage = getMsg('Request Timeout');
              break;
            case 413:
              errorMessage = getMsg('Request Entity Too Large');
              break;
            case 422:
              errorMessage = getMsg('Error');
              break;
            case 423:
              errorMessage = getMsg('Error');
              break;
            case 429:
              errorMessage = getMsg('Too Many Requests');
              break;
            case 500:
              errorMessage = getMsg('Internal server error');
              break;
            case 501:
              errorMessage = getMsg('Not Implemented');
              break;
            case 502:
              errorMessage = getMsg('Bad Gateway');
              break;
            case 503:
              errorMessage = getMsg('Service unavailable');
              break;
            case 504:
              errorMessage = getMsg('Gateway Timeout');
              break;
            case 0:
              errorMessage = getMsg('Please check your internet connection and try again.');
              break;
            default:
              errorMessage = getMsg('An error occurred while processing your request. Please try again. If the problem persists, contact your system administrator.');
              break;
          }

          // Show error message for non-401 errors
          if (error.status !== 401) {
            this.showErrorMessage(errorMessage);
          }
        }

        return throwError(() => new Error(errorMessage));
      })
    );
  }

  private sessionExpired(): void {
    // Clear both auth tokens and redirect to login
    localStorage.removeItem('auth_token');
    localStorage.removeItem('temp_auth_token');
    this.router.navigate(['/login']);
  }

  private forbiddenRoute(): void {
    this.router.navigate(['/dashboard']);
  }

  private showErrorMessage(message: string): void {
    // You can implement toast notification here
    this.toastService.showError(message);
    // console.error('API Error:', message);
  }
}
